import { render } from "./ColisListePage.vue?vue&type=template&id=e058e2e6&ts=true"
import script from "./ColisListePage.vue?vue&type=script&lang=ts"
export * from "./ColisListePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__